import React from 'react';
import { useDrag } from 'react-dnd';
import { ItemTypes } from '../../constants/ItemTypes';
import Card from './Card';

const DraggableCard = ({ card, player, index, idDeck }) => {
  const [{ isDragging }, drag] = useDrag({
    item: { type: ItemTypes.CARD, card, player, index, idDeck },
    canDrag: card.special !== 'slot',
    collect: monitor => ({
      isDragging: !!monitor.isDragging()
    })
  });

  return (
    <div
      ref={drag}
      style={{
        opacity: isDragging ? 0.5 : 1,
        cursor: card.special === 'slot' ? 'auto' : 'move'
      }}
    >
      <Card card={card} />
    </div>
  );
};

export default DraggableCard;
